import * as requestStatuses from './requestStatuses'
import * as liveChatStatuses from './liveChatStatuses'

export const LIVE_CHAT = 'LIVE_CHAT'
export const REQUEST = 'REQUEST'
export const STATUS_ALL = 'all'
export const STATUS_UNREAD = 'unread'

export const FILTER_STATUSES = {
  [STATUS_ALL]: {
    [REQUEST]: [
      { status: requestStatuses.NEW },
      { status: requestStatuses.ACCEPTED },
      { status: requestStatuses.REJECTED },
      { status: requestStatuses.FINISHED, read: false },
    ],
    [LIVE_CHAT]: [
      { status: liveChatStatuses.NEW },
      { status: liveChatStatuses.ACTIVE },
      { status: liveChatStatuses.DISPOSED },
      { status: liveChatStatuses.RESOLVED },
    ],
  },
  read: {
    [REQUEST]: [
      { status: requestStatuses.NEW, read: true },
      { status: requestStatuses.ACCEPTED, read: true },
      { status: requestStatuses.REJECTED, read: true },
      { status: requestStatuses.FINISHED, read: true },
    ],
    [LIVE_CHAT]: [
      { status: liveChatStatuses.NEW, read: true },
      { status: liveChatStatuses.ACTIVE, read: true },
      { status: liveChatStatuses.DISPOSED, read: true },
      { status: liveChatStatuses.RESOLVED, read: true },
    ],
  },
  [STATUS_UNREAD]: {
    [REQUEST]: [
      { status: requestStatuses.NEW, read: false },
      { status: requestStatuses.ACCEPTED, read: false },
      { status: requestStatuses.REJECTED, read: false },
      { status: requestStatuses.FINISHED, read: false },
    ],
    [LIVE_CHAT]: [
      { status: liveChatStatuses.NEW, read: false },
      { status: liveChatStatuses.ACTIVE, read: false },
      { status: liveChatStatuses.DISPOSED, read: false },
      { status: liveChatStatuses.RESOLVED, read: false },
    ],
  },
  confirmed: {
    [REQUEST]: [
      { status: requestStatuses.ACCEPTED },
    ],
    [LIVE_CHAT]: [],
  },
  declined: {
    [REQUEST]: [
      { status: requestStatuses.REJECTED },
    ],
    [LIVE_CHAT]: [],
  },
  closed: {
    [REQUEST]: [
      { status: requestStatuses.FINISHED },
    ],
    [LIVE_CHAT]: [
      { status: liveChatStatuses.RESOLVED },
    ],
  },
}
